import React, { useState } from "react";
import { Slide, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import WheelImg  from "../Assets/Wheels/Mainwheel.jpg"

const WelcomePage: React.FC = () => {
  const [checked, setChecked] = useState(true);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const exitDelay = 600;
  
  const handleChange = () => {
    setChecked((prev) => !prev);
    setTimeout(() => {navigate("/")}, exitDelay - 20)
  };

  return (    
    <div className="App-header SlidePage">
        <Slide
          direction="down"
          in={checked}
          mountOnEnter
          unmountOnExit
          timeout={{ exit: exitDelay }}
        >
          <div onClick={() => handleChange()}>
            <img src={WheelImg} className="App-logo" alt="logo"/>  
            <Typography marginTop={"4em"}>
              {t("intro.click")}
              </Typography>
          </div>
        </Slide>
    </div>
  );
};

export default WelcomePage;
